export enum CustomLineItemAttributesItemType {
  Discount = 'discount',
  Expense = 'expense',
  ExpenseNonTaxable = 'expense-non-taxable',
  Note = 'note',
}
